/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivDocumentRequestPopulatedViewModelGen,
  MrfiktivDocumentRequestResponseControllerGetParamsGen,
  MrfiktivDocumentRequestResponseControllerRespondParamsGen,
  MrfiktivDocumentRequestResponseDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class DocumentRequestResponse<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags document-request-response
   * @name DocumentRequestResponseControllerGet
   * @summary (SCT) Get a document request
   * @request GET:/partner/{partnerId}/document-request-response/{documentRequestId}
   * @secure
   * @response `200` `MrfiktivDocumentRequestPopulatedViewModelGen` The found record
   * @response `400` `void` Bad Request.
   * @response `403` `void` Forbidden.
   * @response `404` `void` Document request not found.
   */
  documentRequestResponseControllerGet = (
    { partnerId, documentRequestId, ...query }: MrfiktivDocumentRequestResponseControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDocumentRequestPopulatedViewModelGen, void>({
      path: `/partner/${partnerId}/document-request-response/${documentRequestId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-request-response
   * @name DocumentRequestResponseControllerRespond
   * @summary (SCT) Respond to a document request with a file upload
   * @request PATCH:/partner/{partnerId}/document-request-response/{documentRequestId}
   * @secure
   * @response `200` `MrfiktivDocumentRequestPopulatedViewModelGen` The updated document request
   */
  documentRequestResponseControllerRespond = (
    { partnerId, documentRequestId, ...query }: MrfiktivDocumentRequestResponseControllerRespondParamsGen,
    data: MrfiktivDocumentRequestResponseDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDocumentRequestPopulatedViewModelGen, any>({
      path: `/partner/${partnerId}/document-request-response/${documentRequestId}`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
}
